import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../../../@shared/services/user.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-check-user-steam',
  templateUrl: './check-user-steam.component.html',
  styleUrls: ['./check-user-steam.component.scss']
})
export class CheckUserSteamComponent {

  public userSteam: Observable<any> = this.userService.checkUserSteam();

  constructor(public dialogRef: MatDialogRef<CheckUserSteamComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private userService: UserService) {
  }

  close() {
    this.dialogRef.close();
  }

}
